export const PLATFORM = {
	ACTIVATE: "activate_iq",
	VIEW: "view_iq",
	REPORTING: "reporting_iq",
	CREATIVE: "creative_iq",
	AERO: "aero"
};

export const PLATFORM_THEME = {
	[PLATFORM.ACTIVATE]: { accent: "#2563EB", selectedBg: "#EBF2FE", hoverBg: "#DEEAFD33" },
	[PLATFORM.VIEW]: { accent: "#DC2626", selectedBg: "#FEF2F2", hoverBg: "#FBDADC33" },
	[PLATFORM.REPORTING]: { accent: "#059669", selectedBg: "#ECFDF5", hoverBg: "#D6F3EA33" },
	[PLATFORM.CREATIVE]: { accent: "#7C3AED", selectedBg: "#F5F3FF", hoverBg: "#F3E8FF33" }
};

export const PLATFORM_LABELS = {
	[PLATFORM.ACTIVATE]: "ActivateIQ",
	[PLATFORM.VIEW]: "ViewIQ",
	[PLATFORM.REPORTING]: "ReportingIQ",
	[PLATFORM.CREATIVE]: "CreativeIQ",
	[PLATFORM.AERO]: "AERO"
};

export const DISABLED_PLATFORMS = [PLATFORM.CREATIVE];